import { render, staticRenderFns } from "./genexPanel.vue?vue&type=template&id=62aeb9f4&scoped=true&"
import script from "./genexPanel.vue?vue&type=script&lang=js&"
export * from "./genexPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aeb9f4",
  null
  
)

export default component.exports